import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { authService } from "../../store/services/ServiceAuth";
import LoginForm from "../login/LoginForm";

function EmailActivationMessage({ email, basketRegistration, setLoginForm, onRegisterStep }) {
    const [code, setCode] = useState("");
    const [sending, setSending] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const [resent, setResent] = useState(false);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState("");

    const confirmCode = async (event) => {
        event.preventDefault();
        setConfirming(true);
        setError("");
        const result = await authService.confirmActivationCode({ email: email, code: code });
        setConfirming(false);
        if (result && result.status === 200) {
            setVerified(true);
            if (onRegisterStep) {
                onRegisterStep("verified");
            }
            return;
        }
        setError("Kód nie je platný.");
    };

    const resendCode = async () => {
        setSending(true);
        setResent(false);
        setError("");
        const result = await authService.resendActivationCode({ email: email });
        setSending(false);
        if (result && result.status === 200) {
            setResent(true);
            return;
        }
        setError("Kód sa nepodarilo odoslať znova.");
    };

    if (verified && !basketRegistration) {
        return (
            <>
                <h2 style={{ margin: "0 0 0.75rem", color: "var(--dark)", fontSize: "1.5rem", textAlign: "center" }}>
                    Účet je overený
                </h2>
                <p style={{ margin: "0 0 1.5rem", color: "#666", textAlign: "center" }}>
                    Môžeš sa prihlásiť.
                </p>
                <LoginForm passwordOnly initialEmail={email} />
            </>
        );
    }

    return (
        <div style={{
            background: "var(--white)",
            borderRadius: "20px",
            border: "1px solid #e0e0e0",
            boxShadow: "0 5px 20px rgba(214, 12, 140, 0.10)",
            width: "100%",
            maxWidth: basketRegistration ? "500px" : "600px",
            margin: "0 auto",
            padding: "2rem 1.5rem",
            boxSizing: "border-box",
            textAlign: "center",
        }}>
            {verified ? (
                <>
                    {!basketRegistration && (
                        <>
                            <h2 style={{ margin: "0 0 0.75rem", color: "var(--dark)", fontSize: "1.5rem" }}>
                                Účet je overený
                            </h2>
                            <p style={{ margin: "0 0 1.5rem", color: "#666" }}>
                                Môžeš sa prihlásiť.
                            </p>
                        </>
                    )}
                    <button
                        type="button"
                        onClick={setLoginForm}
                        className="ui pink big fluid button"
                    >
                        Prihlásiť sa
                    </button>
                </>
            ) : (
                <Form onSubmit={confirmCode}>
                    {!basketRegistration && (
                        <h2 style={{ margin: "0 0 0.75rem", color: "var(--dark)", fontSize: "1.5rem" }}>
                            Odoslali sme ti kód
                        </h2>
                    )}
                    <p style={{ margin: "0 0 1.5rem", color: "#666", lineHeight: 1.5 }}>
                        Kód sme poslali na <strong>{email}</strong>.
                    </p>
                    <Form.Input
                        size="large"
                        fluid
                        label="Aktivačný kód"
                        placeholder="123456"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        style={{ marginBottom: error ? "0.35rem" : "1.25rem", textAlign: "left" }}
                    />
                    {error && (
                        <span style={{ display: "block", textAlign: "left", fontSize: "0.8rem", color: "#db2828", marginBottom: "1.25rem" }}>
                            {error}
                        </span>
                    )}
                    <Form.Button
                        fluid
                        size="big"
                        color="pink"
                        type="submit"
                        loading={confirming}
                        disabled={confirming || code.trim().length === 0}
                        style={{ marginTop: "1rem", marginBottom: "0.75rem" }}
                    >
                        Potvrdiť kód
                    </Form.Button>
                    <div style={{
                        marginTop: "0.5rem",
                        paddingTop: "1.25rem",
                        borderTop: "1px solid rgba(214, 12, 140, 0.1)",
                    }}>
                        <button
                            type="button"
                            onClick={resendCode}
                            disabled={sending}
                            style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                color: "var(--primary)",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontSize: "0.9rem",
                            }}
                        >
                            {sending ? "Odosielam…" : "Odoslať kód znova"}
                        </button>
                        {resent && (
                            <p style={{ margin: "0.75rem 0 0", color: "#21ba45", fontSize: "0.9rem" }}>
                                Nový kód je na ceste.
                            </p>
                        )}
                    </div>
                </Form>
            )}
        </div>
    );
}

export default EmailActivationMessage;
